import { printerService } from "@/services/PrinterService";
import { toast } from "vue3-toastify";
import { i18n } from "./../lang";

const state = {
    printers: [],
    printerRequest: {
        loading: false
    },
    getPrintersRequest: {
        loading: false
    },
    currentPrinter: null,
    printersLoaded: false
}

let printersRequest = null;

const actions = {
    ensurePrinters({state, dispatch}) {
        if (state.printersLoaded) return Promise.resolve(state.printers);
        if (!printersRequest) {
            printersRequest = dispatch('getPrinters').finally(() => {
                printersRequest = null;
            });
        }
        return printersRequest;
    },
    getPrinters({commit}) {
        commit('setPrinterRequest', {loading: false});
        commit('setGetPrintersRequest', {loading: true});
        return printerService.getPrinters()
        .then(response =>{
            commit('setPrinterRequest', {loading: false});
            commit('setGetPrintersRequest', {loading: false});
            commit('updatePrinters', response.data);
            commit('setPrintersLoaded', true);
        })
        .catch(err => {
            commit('setPrinterRequest', {loading: false, message: err});
            commit('setGetPrintersRequest', {loading: false, message: err});
        });
    },
    addPrinter({commit, state}, printer) {
        commit('setPrinterRequest', {loading: true});
        printerService.addPrinter(printer)
            .then(response =>{
                toast.success(i18n.global.t("toast.createSuccess"));
                commit('setPrinterRequest', {loading: false});
                commit("updatePrinters", [...state.printers, response.data]);
                commit('setCurrentPrinter', null);
            })
            .catch(error => {
                toast.error(i18n.global.t("toast.createError"));
                commit('setPrinterRequest', {loading: false, message: error})
            });
    },
    editPrinter({commit, state}, printer) {
        commit('setPrinterRequest', {loading: true});
        printerService.updatePrinter(printer)
            .then(response =>{
                toast.success(i18n.global.t("toast.successEdit"));
                commit('setPrinterRequest', {loading: false});
                const updated = response.data || printer;
                commit("updatePrinters", state.printers.map(item => item.id === updated.id ? updated : item));
                commit('setCurrentPrinter', null);
            })
            .catch(error => {
                toast.error(i18n.global.t("toast.errorEdit"));
                commit('setPrinterRequest', {loading: false, message: error})
            });
    },
    deletePrinter({commit, state}, printer) {
        commit('setPrinterRequest', {loading: false});
        printerService.deletePrinter(printer)
            .then(response =>{
                toast.success(i18n.global.t("toast.deleteSuccess"));
                commit('setPrinterRequest', {loading: false});
                const updatePrinters = state.printers.filter(function(element) {
                    return element.id !== printer.id;
                });
                commit("updatePrinters", updatePrinters);
                commit('setCurrentPrinter', null);
            })
            .catch(error => {
                toast.error(i18n.global.t("toast.deleteError"));
                commit('setPrinterRequest', {loading: false, message: error})
            });
    }
}

const mutations = {
    setPrinterRequest(state, {loading, message}){
        state.printerRequest = {
            loading, message
        };
    },
    setGetPrintersRequest(state, {loading, message}){
        state.getPrintersRequest = {
            loading, message
        };
    },
    updatePrinters(state, printers) {
        state.printers = printers
    },
    setPrintersLoaded(state, loaded) {
        state.printersLoaded = loaded;
    },
    resetPrinters(state) {
        state.printers = [];
        state.printersLoaded = false;
    },
    setCurrentPrinter(state, printer) {
        state.currentPrinter = printer;
        if (printer === null) {
            state.printerRequest = {};
        }
    }
}

export const printer = {
    namespaced: true,
    state,
    actions,
    mutations,
}